const config = {
  apiUrl: import.meta.env.VITE_API_URL,
  API_BASE_URL: import.meta.env.VITE_API_URL,
  isDevelopment: import.meta.env.MODE === 'development',

  monitoring: {
    applicationInsights: {
      connectionString: import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING || null,
      enabled: !!import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING
    }
  }
};

export default config;
